import {
	SEND_PAYMENT,
	ERROR_SEND_PAYMENT,
	GET_PRODUCTS,
	ERROR_PRODUCTS,

	RESET_ALERT_MESSAGE,
	RESET
} from '../../../constants';

const whitelabelState = {
	meta: null,
	confirmationUrl: null,
	paymentPlans: []
};

export default function whitelabelReducer(state = whitelabelState, action) {
	switch (action.type) {
		case SEND_PAYMENT:
			return Object.assign({}, state, {
				meta: action.meta,
				confirmationUrl: action.confirmationUrl
			});

		case GET_PRODUCTS:
			return Object.assign({}, state, {
				meta: action.meta,
				paymentPlans: action.paymentPlans
			});

		case ERROR_PRODUCTS:
		case ERROR_SEND_PAYMENT:
			return Object.assign({}, state, {
				meta: action.meta
			});

		case RESET_ALERT_MESSAGE:
			return Object.assign({}, state, {
				meta: null
			});

		case RESET:
			return Object.assign({}, whitelabelState);

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/containers/whitelabel-page/reducers/index.js